import React, { useMemo } from 'react';
import ImpressionTimeline from '../../../../../../shared/designSystem/components/ImpressionTimeline';
import { getMobileOperatingSystem } from '../../transactions/components/utils';

// =============================================================================
// ImpressionSubTable — timeline of impressions for a single page-view row.
//
// V2 facelift adapter. Maps the legacy page-view impression shape
// (useragent / urlHost / appName / appStoreId / siteName / publisher / etc.)
// into the `<ImpressionTimeline>` primitive's expected shape
// (impressionPublisher / impressionPublisherUrl / impressionPublisherPlatform /
// media / eventId). The primitive owns sort, empty state, device-icon
// auto-detect from the OS string, and the clickable creative-thumb modal.
// =============================================================================

const adaptImpression = (imp, i) => {
  const {
    impressionTime,
    useragent,
    urlHost,
    referrer,
    appName,
    appStoreId,
    siteName,
    creativeId,
    creativeUrl,
    publisher,
  } = imp;

  const OS = getMobileOperatingSystem(useragent);

  // Resolve publisher name + visit URL using the same fallback ladder the
  // legacy view used. Prefers explicit `publisher`, then app-name + store
  // id, then site-name, then the page's url-host.
  let pubName = '';
  let pubUrl = '';

  if (publisher && publisher !== 'N/A') {
    pubName = decodeURI(publisher).replace(/[+_]/g, ' ');
  }

  if (appStoreId && appName) {
    if (!pubName) {
      pubName = decodeURIComponent(appName).replace(/[+_]/g, ' ').split(':').pop();
    }
    pubUrl = decodeURIComponent(appStoreId);
  } else if (siteName) {
    const tempSiteName = decodeURIComponent(siteName)
      .replace(/[+_]/g, ' ')
      .split(':')
      .pop();
    if (!pubName) pubName = tempSiteName;
    if (!pubUrl) pubUrl = referrer || `https://${tempSiteName.trim()}`;
  } else if (urlHost) {
    if (!pubName) pubName = decodeURIComponent(urlHost);
    if (!pubUrl) {
      pubUrl = referrer || (/^https?:\/\//i.test(urlHost) ? urlHost : `https://${urlHost}`);
    }
  }

  return {
    impressionTime,
    impressionPublisher: pubName || undefined,
    impressionPublisherUrl: pubUrl || undefined,
    impressionPublisherPlatform: OS,
    media: creativeUrl || undefined,
    eventId: creativeId || `imp-${i}`,
  };
};

const ImpressionSubTable = ({ impressions = [] }) => {
  const adapted = useMemo(
    () => (Array.isArray(impressions) ? impressions.map(adaptImpression) : []),
    [impressions]
  );

  return <ImpressionTimeline impressions={adapted} sort="newest" showCreativeThumb />;
};

export default ImpressionSubTable;
